/* eslint-disable @next/next/no-img-element */
import Image from 'next/image';
import Slider from "react-slick";
import { useEffect, useState } from 'react';
import { IMG_URL } from "utilities/constants";
import {isArray, isEmpty} from "lodash";
import {countDownTimer, replaceAll} from "utilities/helper";
import { getCookie } from 'framework/libs/cookie';
import { TOKEN_SHOP } from 'framework/store/constants';
import http from "utilities/http";
import { toast } from 'react-toastify';
import Share from "components/share";
import { useRouter } from "next/router";

export default function SlideImage({ imageList, item }) {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    //share
    const [onShare,setOnShare] = useState(false);
    const router = useRouter();
    const [clickImage, setClickImage] = useState(1);

    const settingsDetail1 = {
        arrows: false,
        dots: false,
        fade: true,
        asNavFor: nav2,
        ref: (slider) => setNav1(slider),
        beforeChange: (current, next) => setClickImage(current + 1),
        afterChange: current => setClickImage(current + 1)
    };

    const settingsDetail2 = {
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        asNavFor: nav1,
        ref: (slider) => setNav2(slider)
    };

    const genImageList = (w, h, currentSlider) => {
        return imageList.map((img, index) => {
            return (
                <div key={index} className={"items " + (currentSlider ? "wrap-next-image" : "")}>
                    {/* <Image width={w} height={h} src={IMG_URL + img.file} alt="" /> */}
                    {/* <Image width={w} height={h} src={img.thumb || img.full} alt="" /> */}
                    <img src={img.img || img.full} width={w} height={h} alt="" />
                </div>
            );
        });
    };

    const genBigImageList = (currentSlider) => {
        return imageList.map((img, index) => {
            const isVideo = img.type === 'video';
            let videoUrl = img.videoUrl;
            if (img?.videoUrl?.startsWith('https://www.youtube.com/watch?')) {
                videoUrl = replaceAll(img.videoUrl, 'www.youtube.com/watch?v=', 'www.youtube.com/embed/');
            }
            return (
                <div key={index} className={"items " + (currentSlider ? "wrap-next-image-not-crop" : "")}>
                    {!isVideo && <img src={img.full} alt="" style={{ top: 0, position: 'absolute' }} />}
                    {isVideo &&
                        <iframe style={{ top: '25%', objectFit: 'contain', position: 'absolute', width: '100%', height: '56.25%' }} src={videoUrl} title={img.caption} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                    }
                </div>
            );
        });
    };

    // Check xem đã lưu sản phẩm này hay chưa
    const [wishList, setWishList] = useState([]);
    const [inWishList, setInWishList] = useState(false);

    const fetchData = async () => {
        const res = await http('/rest/V1/wishlist/allItems', {}, {token: 'Bearer ' + getCookie(TOKEN_SHOP)});
        if (isArray(res)) {
            setWishList(res);
        }
    };

    useEffect(() => {
        if(isEmpty(getCookie(TOKEN_SHOP))) return;
        fetchData();
    }, [inWishList]);

    useEffect(() => {
        setInWishList(wishList.some(sanpham => sanpham.sku === item.sku));
    }, [wishList]);

    // Lưu sản phẩm
    const saveProduct = async () => {
        const res = await http('/rest/V1/wishlist/', {}, {
            body: {
                sku: `${item.sku}`
            },
            token: 'Bearer ' + getCookie(TOKEN_SHOP),
            method: 'PUT'
        });
        if (res === true) {
            setInWishList(true);
            // toast.info('Lưu sản phẩm thành công!');
        };
        if (res?.message) toast.error(res.message);
    };

    // Bỏ lưu sản phẩm
    const removeProduct = async () => {
        await fetchData();
        const wishListId = wishList.find(sanpham => sanpham.sku === item.sku);

        // Kiểm tra sản phẩm có tồn tại trong ds đã lưu chưa
        if (!wishListId) {
            setInWishList(false);
            toast.error('Sản phẩm không tồn tại trong danh mục đã lưu!');
            return;
        }

        // Bỏ lưu
        const res = await http('/rest/V1/wishlist/' + wishListId.itemId, {}, {
            token: 'Bearer ' + getCookie(TOKEN_SHOP),
            method: 'DELETE'
        });
        if (res === true) {
            setInWishList(false);
            // toast.info('Bỏ lưu sản phẩm thành công!');
        } 
        if (res === false) {
            setInWishList(true);
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại hoặc liên hệ nhân viên tư vấn!');
        };
        if (res?.message) toast.error(res.message);
    };

    let timeLeft = '';
    if (isArray(item.extension_attributes?.flash_sales_data)) {
        if (item.extension_attributes?.flash_sales_data[0].time_left) {
            timeLeft = item.extension_attributes?.flash_sales_data[0].time_left;
            let time = timeLeft.split(' ngày ')[1];
            const timeArray = time.split(':');

            if (timeArray[0].length == 1) timeArray[0] = '0' + timeArray[0];
            if (timeArray[1].length == 1) timeArray[1] = '0' + timeArray[1];
            if (timeArray[2].length == 1) timeArray[2] = '0' + timeArray[2];
            time = timeArray[0] + ":" + timeArray[1] + ":" + timeArray[2];
            timeLeft = timeLeft.split(' ngày ')[0] + ' ngày ' + time;

            if (timeLeft.split(' ngày ')[0] == 0) {
                timeLeft = timeLeft.split(' ngày ')[1];
            }
        }

        if (item.extension_attributes?.flash_sales_data[0]?.end_at) {
            timeLeft = countDownTimer(item.extension_attributes?.flash_sales_data[0].end_at);
        }
    }

    return (
        <div className="detail_slider-thumb">
            <Share onShare={onShare} setOnShare={setOnShare} url ={router.asPath}/>
            <div className="detail_slider">
                <div className="slider slider-thumb">
                    <Slider {...settingsDetail1}>
                        {!isEmpty(imageList) && genBigImageList(true)}
                    </Slider>
                </div>
                <span className="pagingInfo">
                    {clickImage}/{imageList.length}
                </span>
                {item.extension_attributes?.flash_sales_data && <div className="dealine-sale">
                    <span className="icon-clock" style={{ paddingBottom: 1 }}><img src="/images/icon-clock.svg" alt="" /></span>
                    Flash Sale <span className="sale_count">{timeLeft}</span>
                    {/* <span className="arrow" style={{ paddingBottom: 1 }}><img className="svg" src="/images/icon-arrow-breadcrumb.svg" alt=""/></span> */}
                </div>}
            </div>
            { !isEmpty(imageList) && (imageList.length > 1) && <div className="slider slider-thumb-sub">
                <Slider {...settingsDetail2}>
                    {!isEmpty(imageList) && genImageList(76, 70, false)}
                </Slider>
            </div>}
            <ul className="thumb-control">
                <li>
                    {!inWishList && <a className="save-bookmark" onClick={saveProduct} style={{ cursor: 'pointer' }}><Image width={18} height={23} className="svg" src="/images/icon-bookmark01.svg" alt="" /></a>}
                    {inWishList && <a className="save-bookmark" onClick={removeProduct} style={{ cursor: 'pointer' }}><Image width={18} height={23} className="svg" src="/images/icon-bookmark03.svg" alt="" /></a>}
                </li>
                <li>
                    <a className="save-bookmark" style={{cursor:"pointer"}} onClick={()=>{setOnShare(!onShare);}}>
                        <Image width={28} height={28} className="svg" src="/images/icon-share.svg" alt="" />
                    </a>
                </li>
            </ul>
        </div>
    );
};